import type { IconSvgObject } from './types';

const MinusIcon: IconSvgObject = [
  ["path", { d: "M20.9922 12L2.99219 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default MinusIcon;
